// User role types
export type UserRole = 'super_admin' | 'admin' | 'user' | 'viewer'

export interface User {
  id: number
  username: string
  email: string
  role: UserRole
  is_active: boolean
  avatarUrl?: string
  created_at: string
  last_login?: string
}

export interface LoginCredentials {
  username: string
  password: string
}

export interface LoginResponse {
  access_token: string
  token_type: 'bearer'
  user: User
}

export interface RegisterCredentials {
  username: string
  email: string
  password: string
  confirm_password: string
}

// Permission types
export interface Permission {
  id: number
  name: string
  description: string
  resource: string
  action: string
}

export interface RolePermissions {
  role: UserRole
  permissions: string[]
}

// Define permissions for each role
export const ROLE_PERMISSIONS: Record<UserRole, string[]> = {
  super_admin: [
    // All permissions
    'user:create', 'user:read', 'user:update', 'user:delete',
    'project:create', 'project:read', 'project:update', 'project:delete',
    'scene:create', 'scene:read', 'scene:update', 'scene:delete',
    'script:create', 'script:read', 'script:update', 'script:delete',
    'config:read', 'config:update',
    'knowledge:read', 'knowledge:write',
    'admin:access'
  ],
  admin: [
    // Management permissions
    'user:read', 'user:update',
    'project:create', 'project:read', 'project:update',
    'scene:create', 'scene:read', 'scene:update',
    'script:create', 'script:read', 'script:update',
    'config:read', 'config:update',
    'knowledge:read', 'knowledge:write'
    , 'admin:access'
  ],
  user: [
    // Basic user permissions
    'project:create', 'project:read',
    'scene:create', 'scene:read',
    'script:create', 'script:read',
    'knowledge:read'
  ],
  viewer: [
    'project:read',
    'scene:read',
    'script:read',
    'knowledge:read'
  ]
}

// Helper functions
export function hasPermission(userRole: UserRole, permission: string): boolean {
  return ROLE_PERMISSIONS[userRole]?.includes(permission) || false
}

export function canAccessAdminPanel(userRole: UserRole): boolean {
  return hasPermission(userRole, 'admin:access')
}

export function canManageUsers(userRole: UserRole): boolean {
  return hasPermission(userRole, 'user:create') || hasPermission(userRole, 'user:delete')
}
